import React from 'react';
export function IntroSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-10 mb-12 text-center max-w-4xl mx-auto" data-id="element-2094">
      <p className="text-gray-700 text-lg leading-relaxed" data-id="element-2095">
        EDM Network offers a comprehensive range of wire EDM, sinker EDM,
        driller EDM, and linear motor CNC milling solutions. Browse our product
        categories below to find the right machine for your application.
      </p>
    </div>;
}